import { wrapCreateBrowserRouterV6 } from "@sentry/react";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/react-query";

import { Toaster } from "sonner";

import * as Sentry from "@sentry/react";

import Home from "@/pages/home";
import Unidade from "@/pages/unidade";
import Setor from "@/pages/setor";
import Pedagogico from "@/pages/setor/pedagogico";
import Secretaria from "@/pages/setor/secretaria";
import ServicosPedagogico from "@/pages/setor/pedagogico/servico";
import ServicosSecretaria from "@/pages/setor/secretaria/servico";
import RecuperarSenha from "@/pages/setor/recuperar_senha";
import Solicitacoes from "@/pages/solicitacoes";
import SolicitacaoID from "@/pages/solicitacoes/id";
import AdminPage from "@/pages/admin";
import { Monitoring } from "@/pages/admin/monitoring";
import { AuthProvider } from "@/contexts/auth";

const RouteErrorFallback = ({ error }) => (
  <div style={{ padding: 20 }}>
    <h1 className="font-bold text-lg">Erro inesperado na página</h1>
    <p className="text-zinc-500 text-sm">Fomos notificados e iremos analisar o erro. Retorne em breve.</p>
    <pre>{error?.message}</pre>
  </div>
);

const wrapWithErrorBoundary = (element) => (
  <Sentry.ErrorBoundary fallback={<RouteErrorFallback />}>
    {element}
  </Sentry.ErrorBoundary>
);

const router = wrapCreateBrowserRouterV6(createBrowserRouter)([
  {
    path: "/",
    element: wrapWithErrorBoundary(<Home />),
  },
  {
    path: "/admin",
    element: wrapWithErrorBoundary(<AdminPage />),
  },
  {
    path: "/admin/monitoring",
    element: wrapWithErrorBoundary(<Monitoring />),
  },
  {
    path: "/unidade",
    element: wrapWithErrorBoundary(<Unidade />),
  },
  {
    path: "/setor",
    element: wrapWithErrorBoundary(<Setor />),
  },
  {
    path: "/setor/pedagogico",
    element: wrapWithErrorBoundary(<Pedagogico />),
  },
  {
    path: "/setor/secretaria",
    element: wrapWithErrorBoundary(<Secretaria />),
  },
  {
    path: "/setor/financeiro",
    element: wrapWithErrorBoundary(<Secretaria />),
  },
    {
    path: "/setor/recuperar_senha",
    element: wrapWithErrorBoundary(<RecuperarSenha />),
  },
  {
    path: "/setor/financeiro/:id",
    element: wrapWithErrorBoundary(<ServicosSecretaria />),
  },
  {
    path: "/setor/secretaria/:id",
    element: wrapWithErrorBoundary(<ServicosSecretaria />),
  },
  {
    path: "/setor/pedagogico/:id",
    element: wrapWithErrorBoundary(<ServicosPedagogico />),
  },
  {
    path: "/solicitacoes",
    element: wrapWithErrorBoundary(<Solicitacoes />),
  },
  {
    path: "/solicitacoes/:id",
    element: wrapWithErrorBoundary(<SolicitacaoID />),
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

function Routes() {
  return (
    <AuthProvider>
      <NuqsAdapter>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster richColors position="top-center" />
        </QueryClientProvider>
      </NuqsAdapter>
    </AuthProvider>
  );
}

export default Routes;